import { CLEAR_FILTER, SET_FILTER } from '@/store/mutation-types'

export default {
  namespaced: true,
  state: {
    filter: {
      'source_name': '',
      'program_name': '',
      'enabled': undefined,
      'capture_video': undefined,
    },
  },
  mutations: {
    [SET_FILTER]: (state, filter) => {
      state.filter = filter
    },
    [CLEAR_FILTER]: state => {
      state.filter = []
    },
  },
}
